// extracted by mini-css-extract-plugin
module.exports = {"markdown":"Markdown_markdown__5Mx3E"};